import { useSearch } from "@/contexts/SearchContext";
import { PropertyListingViewType } from "@/enums/property.enum";
import { SwitchPropertyView } from "../../SwitchPropertyView";
import { SortingMenu } from "./SortingMenu";

export const ListFilters = () => {
  const { view } = useSearch();

  return (
    <div className="w-full px-1">
      {view !== PropertyListingViewType.MAP && (
        <div className="flex items-center w-full overflow-hidden justify-between  gap-2">
          <SwitchPropertyView />
          <div className=" flex items-center gap-x-3">
            <SortingMenu />
          </div>
        </div>
      )}
    </div>
  );
};
